/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* VDK Web ProgramGuide Component (@accedo/vdkweb-epg) 7.2.8
* 
*******************************************************************************/
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Direction = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _navigationButton = _interopRequireDefault(require("./navigationButton.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Direction = {
  Up: 'up',
  Down: 'down',
  Right: 'right',
  Left: 'left'
};
exports.Direction = Direction;
var _getStyleForDirection = function _getStyleForDirection(direction, size) {
  switch (direction) {
    case Direction.Up:
      return {
        width: size * 4,
        height: size,
        borderBottomLeftRadius: size * 2,
        borderBottomRightRadius: size * 2
      };
    case Direction.Down:
      return {
        width: size * 4,
        height: size,
        borderTopRightRadius: size * 2,
        borderTopLeftRadius: size * 2
      };
    case Direction.Right:
      return {
        height: size * 4,
        width: size,
        borderBottomLeftRadius: size * 2,
        borderTopLeftRadius: size * 2
      };
    case Direction.Left:
      return {
        height: size * 4,
        width: size,
        borderBottomRightRadius: size * 2,
        borderTopRightRadius: size * 2
      };
    default:
      return {};
  }
};

/**
 * A button for managing program guide navigation and scrolling
 * in different directions (up, down, left, right) with a mouse.
 *
 * By default it's styled differently depending on which direction
 * it's intended to navigate.
 *
 * @param {object} props See propTypes
 * @returns {NavigationButton} A NavigationButton component
 */
var NavigationButton = function NavigationButton(_ref) {
  var direction = _ref.direction,
    top = _ref.top,
    left = _ref.left,
    right = _ref.right,
    bottom = _ref.bottom,
    onClick = _ref.onClick,
    text = _ref.text,
    _ref$visible = _ref.visible,
    visible = _ref$visible === void 0 ? true : _ref$visible,
    _ref$getStyleForDirec = _ref.getStyleForDirection,
    getStyleForDirection = _ref$getStyleForDirec === void 0 ? _getStyleForDirection : _ref$getStyleForDirec,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 40 : _ref$size,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _navigationButton["default"] : _ref$theme;
  if (!visible) {
    return null;
  }
  var style = getStyleForDirection(direction, size);
  return /*#__PURE__*/_react["default"].createElement("button", {
    className: (0, _classnames["default"])(theme.navigationButton),
    onClick: onClick,
    style: _objectSpread(_objectSpread({}, style), {}, {
      top: top,
      left: left,
      right: right,
      bottom: bottom
    })
  }, text);
};
NavigationButton.propTypes = {
  /** The bottom position of the button */
  bottom: _propTypes["default"].number,
  /** The direction in which this button will navigate */
  direction: _propTypes["default"].oneOf(['right', 'left', 'up', 'down']).isRequired,
  /**
   * For overriding the button styling which by default
   * is based on the direction and size prop.
   * ```getStyleForDirection(direction, size)```
   */
  getStyleForDirection: _propTypes["default"].func,
  /** The left position of the button */
  left: _propTypes["default"].number,
  /** Click handler for the button */
  onClick: _propTypes["default"].func,
  /** The right position of the button */
  right: _propTypes["default"].number,
  /**
   * The pixel size of the button, both width and height
   * calculations will be based on this.
   */
  size: _propTypes["default"].number,
  /** The text to display on the button */
  text: _propTypes["default"].string,
  /** Classname API for theming */
  theme: _propTypes["default"].shape({
    down: _propTypes["default"].string,
    left: _propTypes["default"].string,
    navigationButton: _propTypes["default"].string,
    right: _propTypes["default"].string,
    up: _propTypes["default"].string
  }),
  /** The top position of the button */
  top: _propTypes["default"].number,
  visible: _propTypes["default"].bool
};
var _default = /*#__PURE__*/_react["default"].memo(NavigationButton);
exports["default"] = _default;